export default __webpack_public_path__ + "static/media/3coder.407cc63d.png";